export class SelectAutoSubmit extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.listeners.add(this, 'change', this.onChange.bind(this))
  }

  onChange (e) {
    if (!this.form) {
      console.error(`Could not find form for ${this.tagName.toLowerCase()}`)

      return
    }

    if (this.form.requestSubmit) {
      this.form.requestSubmit()
    } else {
      this.form.dispatchEvent(
        new Event('submit', {
          bubbles: true,
          cancelable: true,
        }),
      )
    }
  }

  get form () {
    if (this.hasAttribute('form')) {
      return document.getElementById(this.getAttribute('form'))
    }

    return this.closest('form')
  }
}

if (!customElements.get('select-auto-submit')) {
  customElements.define('select-auto-submit', SelectAutoSubmit)
}
